import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, ShieldCheck, Shield, Gift } from 'lucide-react';
import { trackEvent } from '../utils/metaPixel';
const stack = ['PromptAdsPro — Software completo', '24 ángulos psicológicos pre-cargados', 'Generador de creativos multiformato', 'Guía de inicio rápido (30 min)', 'Actualizaciones gratuitas'];
const bonuses = ['Biblioteca de Hooks para Infoproductores', 'Manual de Estructuras de Anuncios', 'Checklist de Testing para Infoproductores', 'Guión de VSL para Lanzamiento'];
export function OfferSection() {
  return <section id="oferta" className="bg-black py-16 px-4 relative overflow-hidden" data-id="element-100">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1/2 bg-matrix-green/10 blur-[100px] pointer-events-none" data-id="element-101" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-102">
        <div className="text-center mb-8" data-id="element-103">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-heading text-4xl md:text-5xl font-black text-white mb-4" data-id="element-104">
            Todo lo que te llevás hoy
          </motion.h2>
          <p className="font-body text-gray-400 text-lg" data-id="element-105">
            El sistema definitivo para escalar tus campañas sin depender de la
            suerte.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mb-8" data-id="element-106">
          {/* 3D Cubes Image */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative rounded-2xl overflow-hidden border border-matrix-green/20 shadow-[0_0_30px_rgba(0,255,65,0.15)]" data-id="element-107">
            <div className="absolute inset-0 bg-matrix-green/5 mix-blend-overlay pointer-events-none" data-id="element-108" />
            <img src="https://i.postimg.cc/SxwJrH0g/portada-Hotmart-1.webp" alt="PromptAdsPro — Ebook Principal" className="w-full h-auto object-cover" data-id="element-109" />
          </motion.div>

          {/* Pricing & CTA */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-black p-8 md:p-12 rounded-3xl text-center border border-matrix-green/40 shadow-2xl relative glow-green-lg" data-id="element-110">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-matrix-green to-matrix-bright text-black font-bold font-mono px-6 py-2 rounded-full text-sm shadow-lg" data-id="element-111">
              OFERTA ESPECIAL
            </div>

            <div className="mb-4 mt-4" data-id="element-112">
              <span className="text-gray-500 line-through font-heading text-2xl" data-id="element-113">
                USD $160
              </span>
            </div>
            <div className="mb-10 flex items-center justify-center gap-3" data-id="element-114">
              <span className="font-heading font-black text-5xl md:text-7xl text-matrix-green text-glow-green" data-id="element-115">
                9.90USD
              </span>
            </div>

            <ul className="space-y-4 mb-6 text-left max-w-sm mx-auto" data-id="element-116">
              {stack.map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-117">
                  <CheckCircle2 className="w-6 h-6 text-matrix-green flex-shrink-0" data-id="element-118" />
                  <span className="font-body font-medium text-gray-200 text-lg" data-id="element-119">
                    {item}
                  </span>
                </li>)}
            </ul>

            {/* Bonos incluidos */}
            <div className="mb-10 text-left max-w-sm mx-auto" data-id="element-120">
              <div className="flex items-center gap-2 mb-3 pb-2 border-b border-matrix-green/20" data-id="element-121">
                <Gift className="w-5 h-5 text-matrix-green" data-id="element-122" />
                <span className="font-mono text-matrix-green text-xs font-bold uppercase tracking-wider" data-id="element-123">
                  + 4 Bonos Gratis
                </span>
              </div>
              <ul className="space-y-3" data-id="element-124">
                {bonuses.map((bonus, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-125">
                    <Gift className="w-5 h-5 text-matrix-green/70 flex-shrink-0" data-id="element-126" />
                    <span className="font-body font-medium text-gray-300 text-base" data-id="element-127">
                      {bonus}
                    </span>
                  </li>)}
              </ul>
            </div>

            <motion.a href="https://pay.hotmart.com/I104697906M" target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('InitiateCheckout', {
            content_name: 'PromptAdsPro',
            value: 9.9,
            currency: 'USD'
          })} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full relative inline-flex items-center justify-center gap-3 bg-matrix-green hover:bg-matrix-green-dark text-black font-heading font-bold text-2xl py-6 px-8 rounded-xl shadow-[0_10px_30px_rgba(0,255,65,0.4)] transition-all duration-300 pulse-glow" data-id="element-128">
              <Download className="w-7 h-7" data-id="element-129" />
              <span data-id="element-130">¡Quiero la Oferta!</span>
            </motion.a>

            <div className="mt-8 flex items-center justify-center gap-2 text-gray-400 text-sm font-body" data-id="element-131">
              <ShieldCheck className="w-5 h-5 text-matrix-green" data-id="element-132" />
              <span data-id="element-133">Garantía de 7 días. Riesgo cero.</span>
            </div>
          </motion.div>
        </div>

        {/* Garantía de 7 días */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="max-w-2xl mx-auto mt-12 bg-premium-mid/60 border border-matrix-green/30 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-134">
          <div className="absolute inset-0 bg-gradient-to-b from-matrix-green/5 to-transparent pointer-events-none" data-id="element-135" />

          <div className="relative z-10" data-id="element-136">
            <div className="w-16 h-16 rounded-full bg-matrix-green/15 border border-matrix-green/30 flex items-center justify-center mx-auto mb-5 shadow-[0_0_25px_rgba(0,255,65,0.2)]" data-id="element-137">
              <Shield className="w-8 h-8 text-matrix-green" data-id="element-138" />
            </div>

            <h3 className="font-heading font-bold text-2xl md:text-3xl text-white mb-3" data-id="element-139">
              Garantía de{' '}
              <span className="text-matrix-green text-glow-green" data-id="element-140">7 Días</span>{' '}
              — Riesgo Cero
            </h3>

            <p className="font-body text-gray-300 text-base md:text-lg leading-relaxed max-w-lg mx-auto mb-4" data-id="element-141">
              Si en los próximos 7 días sentís que PromptAdsPro no es para vos,
              te devolvemos el 100% de tu dinero. Sin preguntas, sin vueltas.
            </p>

            <p className="font-mono text-matrix-green/70 text-sm uppercase tracking-wider" data-id="element-142">
              Tu inversión está 100% protegida
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}